import {Feature} from '../reducers/environmentReducer';
import {FeatureFlag} from '../../../@type/features';

export function initBotProtection() {
	if (!Feature.enabled(FeatureFlag.BOT_PROTECTION)) {
		return;
	}

	installCaptchaScript();
}

function installCaptchaScript() {
	const script = document.createElement('script');
	script.setAttribute('src', 'https://www.google.com/recaptcha/api.js?render=' + Feature.metadata(FeatureFlag.BOT_PROTECTION, 'site_key'));

	script.async = true;
	script.defer = true;

	document.body.appendChild(script);
}

/**
 * Returns a string (recaptcha token or placeholder) that gets appended to form data for captcha validation
 */
export async function getCaptchaToken(): Promise<string> {
	if (!Feature.enabled(FeatureFlag.BOT_PROTECTION)) {
		return Promise.resolve('placeholder');
	}

	return new Promise(resolve => {
		grecaptcha.ready(async () => {
			try {
				const token = await grecaptcha.execute(Feature.metadata(FeatureFlag.BOT_PROTECTION, 'site_key') ?? '', {action: 'EXPRESS_CHECKOUT'});
				resolve(token);
			} catch (error: any) {
				resolve('');
			}
		});
	});
}
